import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faVuejs,
  faFacebookF,
  faTwitter,
  faLinkedinIn,
  faInstagram,
  faYoutube,
  faGithub,
} from "@fortawesome/free-brands-svg-icons";
import {
  faSpinner,
  faAlignLeft,
  faBell,
  faClock,
  faLightbulb,
  faWifi,
  faBriefcase,
  faTag,
  faGavel,
  faMapMarkerAlt,
  faPen,
  faCommentAlt,
  faCircle,
  faEnvelope,
  faPhone,
  faCopyright,
  faBookmark,
  faTrash,
  faMicrophone,
  faVideo,
  faPaperclip,
  faEllipsisV,
  faLock,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faBookmark as farBookmark } from "@fortawesome/free-regular-svg-icons";

library.add(
  faVuejs,
  faFacebookF,
  faTwitter,
  faLinkedinIn,
  faInstagram,
  faYoutube,
  faGithub,
  faSpinner,
  faAlignLeft,
  faBell,
  faClock,
  faLightbulb,
  faWifi,
  faBriefcase,
  faTag,
  faGavel,
  faMapMarkerAlt,
  faPen,
  faCommentAlt,
  faCircle,
  faEnvelope,
  faPhone,
  faCopyright,
  faBookmark,
  faTrash,
  faMicrophone,
  faVideo,
  faPaperclip,
  faEllipsisV,
  farBookmark,
  faLock
);

export default FontAwesomeIcon